import {
  getFontCss,
  Popup,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { useDispatch } from 'react-redux'
import TestId from 'src/components/TestId/TestId'
import { useTranslate } from 'src/localization/Trns'
import { createSetIsAddMissingInformationExpenseReportPopupOpen } from 'src/redux/actions/app.actions'
import { css } from 'styled-components'

const AttachMissingInformationExpenseReportPopup: React.FC =
  (): React.ReactElement => {
    const translate = useTranslate()

    const dispatch = useDispatch()

    const closePopup = (): void => {
      dispatch(createSetIsAddMissingInformationExpenseReportPopupOpen(false))
    }

    return (
      <Popup
        onClickClose={closePopup}
        showCloseButton
        css={css`
          display: flex;
          position: relative;
        `}
      >
        <div
          css={css`
            width: 100%;
            display: flex;
            flex-direction: column;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                32,
                styleConstants.colors.red,
                styleConstants.fontFamilies.medium,
              )};
              margin-bottom: 30px;
            `}
          >
            {translate('Add Missing Information')}
          </span>
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
              margin-bottom: 20px;
            `}
          >
            <TestId testId={'missingInformationMessage'}>
              {translate(
                'Looks like there is missing information in your expenses.',
              )}
            </TestId>
          </span>
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.medium,
              )};
            `}
          >
            {translate(
              'Please add the missing information to submit your report.',
            )}
          </span>
        </div>
      </Popup>
    )
  }

export default AttachMissingInformationExpenseReportPopup
